import { infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';

import {
  notiApi,
  QK_FETCH_NOTIFICATIONS,
  type IGetNotiResponse,
} from '~/requests/notiApi';
import type { TListResponse } from '~/types';

type GetNotiOptionsParams = {
  enabled?: boolean;
};

export function getNotiOptions({
  enabled,
}: GetNotiOptionsParams): Omit<
  ReturnType<
    typeof infiniteQueryOptions<
      TListResponse<IGetNotiResponse>,
      Error,
      InfiniteData<TListResponse<IGetNotiResponse>, unknown>,
      Array<string>,
      number
    >
  >,
  'queryFn'
> {
  return infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: [QK_FETCH_NOTIFICATIONS],
    queryFn: notiApi.getNotifications,
    getNextPageParam: ([, meta]) => {
      return meta.nextPage;
    },
    getPreviousPageParam: ([, meta]) => {
      return meta.prevPage ?? 1;
    },
    refetchInterval: 120000,
    enabled: enabled ?? true,
  });
}
